<div class="footer-container">
    <strong>2026 © Tecnalia Research & Innovation</strong>
</div>